import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	JSM_TEAM_RESPONDER_FIELD,
	JSM_USER_RESPONDER_GQL_FIELD,
	RESPONDERS_CF_TYPE,
	ISSUE_FIELD_STRING_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggNodeToLegacyField,
	transformAggConnection,
} from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformJiraResponderToLegacyResponder = (responder) => {
	if (responder == null) {
		return undefined;
	}

	switch (responder.__typename) {
		case JSM_USER_RESPONDER_GQL_FIELD: {
			if (responder.user === null) {
				return undefined;
			}

			return {
				ari: responder.user.canonicalAccountId,
				avatarUrl: responder.user.picture,
				name: responder.user.name,
				type: 'user',
			};
		}

		case JSM_TEAM_RESPONDER_FIELD: {
			return {
				ari: responder.teamId,
				name: responder.teamName,
				type: 'team',
			};
		}
		default:
			return undefined;
	}
};

export const transformAggJSMRespondersToLegacyField: FieldTransformer<typeof RESPONDERS_CF_TYPE> = (
	node,
) => {
	if (node.type !== RESPONDERS_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null, // See BENTO-11795
		value: transformAggConnection(
			node.respondersConnection,
			transformJiraResponderToLegacyResponder,
		),
		schema: {
			configuration: null,
			custom: RESPONDERS_CF_TYPE,
			items: ISSUE_FIELD_STRING_CF_TYPE,
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
